import { IchatNotification, Inotification } from '@typings/notification/notification.interface';
import { atom, AtomEffect, DefaultValue } from 'recoil';
import { fuego } from '@store/firebase/index';

export interface NotificationSettings {
    soundEnabled: boolean;
    volume: number;
    soundUrl: string;
    useFallbackBeep: boolean;
    systemNotification: boolean;
    mobileOptimized: boolean;
    // 알림 타입별
    chatNotification: boolean;
    commentNotification: boolean;
    guestbookNotification: boolean;
    giftNotification: boolean;
    replyNotification: boolean;
    taggedNotification: boolean;
    battleNotification: boolean;
    questNotification: boolean;
    dispatchNotification: boolean;
}

const NOTIFICATION_SETTINGS_KEY = 'notification_settings';

export const defaultNotificationSettings: NotificationSettings = {
    soundEnabled: true,
    volume: 50,
    soundUrl: '/assets/sounds/message_sent.mp3',
    useFallbackBeep: true,
    systemNotification: true,
    mobileOptimized: true,
    chatNotification: true,
    commentNotification: true,
    guestbookNotification: true,
    giftNotification: true,
    replyNotification: true,
    taggedNotification: true,
    battleNotification: true,
    questNotification: true,
    dispatchNotification: true,
};

const localStorageEffect: AtomEffect<NotificationSettings> = ({ setSelf, onSet }) => {
    try {
        const saved = localStorage.getItem(NOTIFICATION_SETTINGS_KEY);
        if (saved) {
            setSelf({ ...defaultNotificationSettings, ...JSON.parse(saved) });
        }
    } catch { }

    onSet((newValue) => {
        try {
            if (newValue instanceof DefaultValue) {
                localStorage.removeItem(NOTIFICATION_SETTINGS_KEY);
            } else {
                localStorage.setItem(NOTIFICATION_SETTINGS_KEY, JSON.stringify(newValue));
                // 로그인 상태이면 Firestore에도 저장
                const uid = fuego.auth().currentUser?.uid;
                if (uid) {
                    fuego.db
                        .collection('users')
                        .doc(uid)
                        .set({ notificationSettings: newValue }, { merge: true })
                        .catch(() => {});
                }
            }
        } catch { }
    });
};

export const notificationSettingsState = atom<NotificationSettings>({
    key: 'notificationSettingsState',
    default: defaultNotificationSettings,
    effects_UNSTABLE: [localStorageEffect],
});

export const lastNotificationTimeState = atom<number>({
    key: 'lastNotificationTimeState',
    default: 0,
});

/**
 * 미읽음 알림 리스트 (is_seen === false).
 * useUnreadNotifications 훅이 Firestore 구독 결과를 이 atom에 동기화한다.
 * NotificationBtn · NotificationBrowserAlert 등 여러 곳에서 공유 소비.
 */
export const unreadNotificationsState = atom<Inotification[]>({
    key: 'unreadNotificationsState',
    default: [],
});

export const chatMessageNotificationState = atom<IchatNotification>({
    key: 'chatMessageNotificationState',
    default: {
        show: false,
        unRead: [],
        latestDoc: {
            type: 'comment',
            contents: '',
            sender: '',
            receiver: null,
            createdAt: new Date(),
            boardName: '',
            collectionPath: '',
            postId: null,
            postTitle: '',
            is_seen: false,
        },
        id: '',
    },
});